import Vue from "vue";
import Router from "vue-router";
import index from "@/views/index";

import Home from "@/views/Home/Home";
import About from "@/views/About/About";
import Cooperation from "@/views/Cooperation/Cooperation";
import Service from "@/views/Service/Service";
import News from "@/views/News/News";
import Contact from "@/views/Contact/Contact";
import error from "@/views/404";

import NewsDetails1 from "@/views/News/NewsDetails1";
import NewsDetails2 from "@/views/News/NewsDetails2";
import NewsDetails3 from "@/views/News/NewsDetails3";
import NewsDetails4 from "@/views/News/NewsDetails4";
import NewsDetails5 from "@/views/News/NewsDetails5";
import NewsDetails6 from "@/views/News/NewsDetails6";

Vue.use(Router);

//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

export default new Router({
  mode: "history", // 路由模式：hash(默认)，history模式
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      children: [
        {
          path: "/",
          component: Home
        },
        {
          path: "/Home",
          name: "Home",
          redirect: "/",
          component: Home
        },
        {
          path: "/About",
          name: "About",
          component: About
        },
        {
          path: "/Cooperation",
          name: "Cooperation",
          component: Cooperation
        },
        {
          path: "/Service",
          name: "Service",
          component: Service
        },
        {
          path: "/News",
          name: "News",
          component: News
        },
        {
          name: "News",
          path: "/News/1",
          component: NewsDetails1
        },
        {
          name: "News",
          path: "/News/2",
          component: NewsDetails2
        },
        {
          name: "News",
          path: "/News/3",
          component: NewsDetails3
        },
        {
          name: "News",
          path: "/News/4",
          component: NewsDetails4
        },
        {
          name: "News",
          path: "/News/5",
          component: NewsDetails5
        },
        {
          name: "News",
          path: "/News/6",
          component: NewsDetails6
        },
        {
          path: "/Contact",
          name: "Contact",
          component: Contact
        }
      ]
    },
    {
      path: "/404",
      name: "未找到",
      component: error
    },
    {
      path: "*", // 此处需特别注意置于最底部
      redirect: "/404"
    }
  ],
  // 所有页面渲染后滚动至顶部
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  }
});



// WEBPACK FOOTER //
// ./src/router/index.js